import React, { useState } from "react";
import { Input, Space, Select } from "antd";
import { GetUsers_getUsers } from "../../__generated__/gql-types/GetUsers";
import { Roles } from "../../__generated__/gql-types/globalTypes";

const { Search } = Input;

interface Props {
  data: GetUsers_getUsers[];
  dataSource: GetUsers_getUsers[];
  setdataSource: React.Dispatch<
    React.SetStateAction<GetUsers_getUsers[] | null>
  >;
}

const InputSearch: React.FC<Props> = ({ data, dataSource, setdataSource }) => {
  const [searchText, setSearchText] = useState("");
  const [roleFilter, setRoleFilter] = useState<string | null>(null);

  const applyFilters = (text: string, role: string | null) => {
    let filteredData = [...data];
    
    if (text) {
      filteredData = filteredData.filter((user) =>
        user.email?.toLowerCase().includes(text.toLowerCase())
      );
    }
    
    if (role && role !== "all") {
      filteredData = filteredData.filter((user) => user.role === role);
    }
    
    setdataSource(filteredData);
  };
  
  const onSearch = (value: string) => {
    setSearchText(value);
    applyFilters(value, roleFilter);
  };
  
  const onRoleChange = (value: string) => {
    setRoleFilter(value === "all" ? null : value);
    applyFilters(searchText, value === "all" ? null : value);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{ width: '100%' }}>
        <Search 
          placeholder="Buscar por email" 
          onSearch={onSearch} 
          style={{ width: 300 }}
          allowClear
          enterButton 
        />
        <Select
          placeholder="Filtrar por rol"
          style={{ width: 150, border: '1px solid #d9d9d9', borderRadius: '2px' }}
          onChange={onRoleChange}
          defaultValue="all"
          options={[
            { value: 'all', label: 'Todos' },
            { value: Roles.teacher, label: 'Profesor' },
            { value: Roles.student, label: 'Alumno' },
          ]}
        />
      </Space>
    </Space>
  );
};

export default InputSearch;
